import { render } from "./DropdownWrapper.vue?vue&type=template&id=fbef594a&scoped=true&ts=true"
import script from "./DropdownWrapper.vue?vue&type=script&lang=ts"
export * from "./DropdownWrapper.vue?vue&type=script&lang=ts"

import "./DropdownWrapper.vue?vue&type=style&index=0&id=fbef594a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbef594a"]])

export default __exports__